module.exports = __webpack_public_path__ + "assets/img/ic-message-gray.87d4b7c7.svg";